import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.role.permissions,
        label: 'Permissions',
        permission: PERMISSIONS.roles.tabs.permissions.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.role.logs,
        label: 'Logs',
        permission: PERMISSIONS.roles.tabs.logs.read,
        id: '2',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
